import React from 'react';
import { NavLink, Outlet, useLocation, Navigate } from 'react-router-dom';
import { Calculator, FileText, BarChart3 } from 'lucide-react';

const Reports: React.FC = () => {
  const location = useLocation();

  // Redirect to management-accounts if the path is just /reports
  if (location.pathname === '/reports' || location.pathname === '/reports/') {
    return <Navigate to="management-accounts" replace />;
  }
  
  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      {/* Horizontal Sub-navigation */}
      <div className="border-b border-slate-200 mb-6">
        <nav className="-mb-px flex space-x-4 sm:space-x-8 overflow-x-auto scrollbar-hide" aria-label="Tabs">
          <NavLink
            to="management-accounts"
            className={({ isActive }) =>
              `whitespace-nowrap py-4 px-2 sm:px-1 border-b-2 font-medium text-sm transition-all duration-200 min-w-fit flex-shrink-0 touch-manipulation ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              }`
            }
          >
            <Calculator className="w-5 h-5 mr-2 inline-block" />
            <span className="hidden sm:inline">Management Accounts</span>
            <span className="sm:hidden">Mgmt</span>
          </NavLink>
          <NavLink
            to="financial-reports"
            className={({ isActive }) =>
              `whitespace-nowrap py-4 px-2 sm:px-1 border-b-2 font-medium text-sm transition-all duration-200 min-w-fit flex-shrink-0 touch-manipulation ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              }`
            }
          >
            <FileText className="w-5 h-5 mr-2 inline-block" />
            <span className="hidden sm:inline">Financial Reports</span>
            <span className="sm:hidden">Reports</span>
          </NavLink>
          <NavLink
            to="cap-table"
            className={({ isActive }) =>
              `whitespace-nowrap py-4 px-2 sm:px-1 border-b-2 font-medium text-sm transition-all duration-200 min-w-fit flex-shrink-0 touch-manipulation ${
                isActive
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-slate-500 hover:text-slate-700 hover:border-slate-300'
              }`
            }
          >
            <BarChart3 className="w-5 h-5 mr-2 inline-block" />
            <span className="hidden sm:inline">Cap Table</span>
            <span className="sm:hidden">Cap</span>
          </NavLink>
        </nav>
      </div>

      {/* Page Content */}
      <div>
        <Outlet />
      </div>
    </div>
  );
};

export default Reports; 